import { styled } from "@mui/material/styles";
import _ from "lodash";
import React, { forwardRef, FunctionComponent, useRef, useState } from "react";
import TurntableIcon from "../icon/TurntableIcon";
import CsiImage from "../image/CsiImage";
import Box, { BoxProps } from "./Box";

const RootBox = styled(Box)({
	position: "relative",
	textAlign: "center",
	width: "100%",
	height: "100%",
});

export interface ThumbnailImageBoxProps extends BoxProps {
	/* conditionally hide the turntable icon (e.g. Lightbox) */
	hideIcon: boolean;

	/* image sources to be shown */
	image: string;

	/* indicates if turntable or singular image */
	isTurntable: boolean;

	/* indicate whether image is padded or not. used for setting spacing on turntable icon */
	paddedImage: boolean;
}

const ThumbImageBox: FunctionComponent<ThumbnailImageBoxProps> = forwardRef((props, ref) => {
	const { isTurntable, image, hideIcon, paddedImage, children, ...otherProps } = props;

	return (
		<RootBox
			{...otherProps}
		>
			<CsiImage src={image} />
			{isTurntable && !hideIcon && (
				<TurntableIcon
					sx={{
						position: "absolute",
						right: paddedImage ? 4 : 2,
						bottom: paddedImage ? 4 : 2,
					}}
				/>
			)}
		</RootBox>
	);
});

export default ThumbImageBox;
